<template>
    <div class="main_container">
        <div class="view_title">{{$t('title_input_name_view')}}</div>

        <div class="input_container" style="">
            <div style="font-size:20px;">이름을 입력하세요</div>
            <input class="input_name" v-model="player_name" type="text" placeholder="플레이어 이름" />
        </div>

        <div class="bottom_btn_container">
            <div class="bottom_one_btn" @click="register">{{$t('btn_register_ok')}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InputPlayersView',
    data() {
        return {
            player_name: '',
        }
    },

    mounted() {
        let game = this.$getCurrentGame()
        if(game.player_name != null) {
            this.$router.push('/sectionList')
        }
    },

    methods: {
        register: function() {
            if(this.player_name.length == 0) {
                return
            }

            let game = this.$getCurrentGame()
            game.player_name = this.player_name
            this.$setCurrentGame(game)

            this.$router.push('/tutorial')
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input_name{
    font-size: 36px;
    padding: 10px;
    width: 70vw;
    text-align: center;
    background-color: transparent;
    border: none;
    border-bottom: 2px solid black;
}

/* pc */
@media screen and (min-width: 415px) {
    .input_container {
        margin-top:80px;
        margin-bottom:200px;
        text-align:center;
    }
}

/* mobile */
@media screen and (max-width: 414px) {
    .input_container {
        margin-top:80px;
        margin-bottom:230px;
        text-align:center;
    }
}
</style>
